import React from 'react';
import { getResolveJSON } from '../../../util/fetch';
import { HouseStyleCard } from '../../card/house_style_card';
import { useQuery } from '@tanstack/react-query';
import { ProductStyleList } from '../../../domain/product/product_style_list';
import { CardPanel } from '../../panel/card_panel';
import { getBaseURL } from '../../../config/runtime';

export interface Props {
  productId: string;
  styleProductId: string;
  onSelect: (styleProductId: string) => void;
  onClose: () => void;
}

export function ProductStyleCardPanel(props: Props) {
  const { productId, styleProductId, onSelect, onClose } = props;

  const fetchStyles = async () => {
    const url = `${getBaseURL()}/v1/client/product-styles/${productId}`;
    const resp = await getResolveJSON(url);
    return resp as ProductStyleList;
  };

  const { status, data } = useQuery<ProductStyleList>({
   queryKey: ['product_styles', productId],
   queryFn: fetchStyles,
  });

  const cards = status === 'loading'
  ? []
  : data?.data.map((style) => {
    const extStyle = {
      ...style,
      is_selected: style.product_id === styleProductId,
    };

    return (
      <HouseStyleCard
        key={style.product_id}
        data={extStyle}
        onSelect={onSelect}
      />
    );
  });

  return (
    <CardPanel
      title="Styles"
      cards={cards}
      onSelect={onSelect}
      onClose={onClose}
    />
  );
}
